import React, {useContext, useState} from "react";
import {CustomerTypeContext, isCustomerCompany} from "../../../context/customer-type-context";
import InstallmentCalculator from "./InstallmentCalculator";
import CreditInstallmentCalculator from "./CreditInstallmentCalculator";
import LoanInstallmentCalculator from "./LoanInstallmentCalculator";

const TAB_LEASING = "LEASING";
const TAB_KREDYT = "KREDYT";
const TAB_POZYCZKA = "POZYCZKA";

function InstallmentCalculatorTabs(props) {

    const customerContext = useContext(CustomerTypeContext);
    const isCompany = isCustomerCompany(customerContext);

    const TAB_LABELS = {
        [TAB_LEASING]: isCompany ? "Leasing" : "Leasing konsumencki",
        [TAB_KREDYT]: "Kredyt",
        [TAB_POZYCZKA]: "Pożyczka",
    };
    const salesDocument = props.offer.salesDocument;
    const longVehicleId = String(props.offer.id).length > 6;

    const showLeasing = salesDocument !== "VAT_MARZA";
    const showKredyt = longVehicleId;
    const showPozyczka = isCompany && longVehicleId;

    const visibleTabs = [
        showLeasing && TAB_LEASING,
        showKredyt && TAB_KREDYT,
        showPozyczka && TAB_POZYCZKA,
    ].filter(Boolean);

    const [activeTab, setActiveTab] = useState(() => visibleTabs[0] || TAB_LEASING);

    const currentTab = visibleTabs.includes(activeTab) ? activeTab : visibleTabs[0];

    const renderCalculator = () => {
        switch (currentTab) {
            case TAB_LEASING:
                return (
                    <InstallmentCalculator
                        {...props}
                        calculatorUrl="/calculation/leasing"
                        allowedCalculationParametersUrl={
                            "/calculation/allowed-calculation-parameters?vehicleId=" + props.offer.id
                        }
                        buyoutAlwaysVisible={true}
                        extraCalculationParams={{ vehicleId: props.offer.id }}
                        reservationStrategy={props.onShowOrderClick}
                    />
                );
            case TAB_KREDYT:
                return (
                    <CreditInstallmentCalculator
                        {...props}
                        reservationStrategy={props.onShowOrderClickForCredit}
                    />
                );
            case TAB_POZYCZKA:
                return (
                    <LoanInstallmentCalculator
                        {...props}
                        reservationStrategy={props.onShowOrderClickForCredit}
                    />
                );
            default:
                return null;
        }
    };

    if (visibleTabs.length === 0) return null;

    const isSolo = visibleTabs.length === 1;

    return (
        <div className="calc-tabs">
            <div className={"calc-tabs__header" + (isSolo ? " calc-tabs__header--solo" : "")}>
                {visibleTabs.map(tab => (
                    <button
                        key={tab}
                        className={"calc-tabs__tab" + (currentTab === tab ? " calc-tabs__tab--active" : "")}
                        onClick={() => setActiveTab(tab)}
                        type="button"
                    >
                        {TAB_LABELS[tab]}
                    </button>
                ))}
            </div>
            <div className="calc-tabs__content">
                {renderCalculator()}
            </div>
        </div>
    );
}

export default InstallmentCalculatorTabs;
